export const ERROR = 'ERROR';
export const BUSY = 'BUSY';
export const VEHICLE_TYPE = 'VEHICLE_TYPE';
export const FUEL_TYPE = 'FUEL_TYPE';
export const DISPLAY_RESULT = 'DISPLAY_RESULT';
export const FUEL_PRICE_ELECTRIC = 'FUEL_PRICE_ELECTRIC';
export const FUEL_PRICE_PETROL = 'FUEL_PRICE_PETROL';
export const FUEL_PRICE_DIESEL = 'FUEL_PRICE_DIESEL';
export const MILEAGE = 'MILEAGE';
export const GENERIC_VEHICLES = 'GENERIC_VEHICLES';
export const EV_CARS = 'EV_CARS';
export const EV_VANS = 'EV_VANS';
export const SELECTED_VEHICLE = 'SELECTED_VEHICLE';
export const REMOVE_ERROR = 'REMOVE_ERROR';